import { HttpEventType, HttpResponse } from "@angular/common/http";
import { Component, ElementRef, Inject, OnInit, ViewChild } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { MatTableDataSource } from "@angular/material/table";
import { NotifierService } from "angular-notifier";
import { timeout } from "rxjs/operators";
import { TestArea } from "src/app/common/test-area";
import { ApiService } from "src/app/services/api.service";
import { FilesService } from "src/app/services/files.service";
import { ErrorHelper } from "../../common/ErrorHelper";
import { User } from "../../model/user";
import { AppComponent } from "../../app.component";

export interface GlobalConfig {
  fileName: string;
  content: string;
}

const REGEXP_FILE_NAME = new RegExp(
  "^(asset_profile|rhd_group_of_countries|brand_group_of_countries|default_country_rules|country_list|version_country_mapping|visibility_configuration).*.xml$"
);

@Component({
  selector: "app-manage-global-configs",
  templateUrl: "./manage-global-configs.component.html",
  styleUrls: ["./manage-global-configs.component.css"],
})
export class ManageGlobalConfigsComponent implements OnInit {
  @ViewChild("fileInput", { static: false }) fileInput: ElementRef;

  selectedFiles: FileList;
  validatedFiles: File[];
  progressInfos = [];

  testArea = TestArea;
  selectedClass = "embargo";
  selectedTestArea = TestArea.EMBARGO;

  displayedColumns: string[] = ["fileName", "showFileContent"];
  dataSource: MatTableDataSource<GlobalConfig>;

  constructor(
    private apiService: ApiService,
    private filesService: FilesService,
    private notifierService: NotifierService,
    public dialog: MatDialog,
    public app: AppComponent
  ) {
    this.app.getUserData().then(
      function (user: User): void {
        if (user.hasEmbargoPermissions()) {
          this.selectTestArea(TestArea.EMBARGO);
        } else {
          this.selectTestArea(TestArea.PREPROD);
        }
      }.bind(this)
    );
  }

  ngOnInit(): void {
    this.dataSource = new MatTableDataSource();
  }

  selectTestArea(test: TestArea): void {
    this.selectedTestArea = test;
    this.selectedClass = this.selectedTestArea
      .toLowerCase()
      .split(" ")
      .find((e) => true);
    this.loadGlobalConfigsAsync();
  }

  async loadGlobalConfigsAsync(): Promise<any> {
    try {
      await this.loadGlobalConfigs();
    } catch (error) {
      console.log(error);
    }
  }

  loadGlobalConfigs(): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      return this.apiService
        .getGlobalConfigs(this.selectedTestArea)
        .toPromise()
        .then(
          (data) => {
            const configs = data;
            this.dataSource = new MatTableDataSource(configs);
            console.log("Fetched the global configs");
            resolve(true);
          },
          (error) => {
            const errorMessage = ErrorHelper.disectError("load global configs", error);
            this.notifierService.notify("error", errorMessage);
            resolve(false);
          }
        );
    });
  }

  showFileContent(content: string): void {
    this.dialog.open(DialogDataFileContentComponent, {
      data: {
        text: content,
      },
      width: "1000px",
      maxWidth: "100vw",
    });
  }

  onClick(): void {
    this.fileInput.nativeElement.click();
  }

  selectFiles(event): void {
    this.progressInfos = [];
    this.validatedFiles = [];

    this.selectedFiles = event.target.files;
    for (let i = 0; i < this.selectedFiles.length; i++) {
      const currentFile = this.selectedFiles.item(i);
      if (!this.validateFile(currentFile.name)) {
        const msg = "File name " + currentFile.name + " do not match the expected format!";
        this.notifierService.notify("error", msg);
      } else {
        this.validatedFiles.push(currentFile);
        this.progressInfos.push({ value: 0, fileName: currentFile.name });
      }
    }
  }

  upload(): void {
    this.validatedFiles.forEach((file, index) => {
      this.filesService
        .uploadGlobal(file, this.selectedTestArea)
        .pipe(timeout(60000))
        .subscribe(
          (event) => {
            if (event.type === HttpEventType.UploadProgress) {
              this.progressInfos[index].value = Math.round((100 * event.loaded) / event.total);
            } else if (event instanceof HttpResponse) {
              this.notifierService.notify("success", event.body.message);
            }
          },
          (error) => {
            const errorMessage = ErrorHelper.disectError("Could not upload the file: " + file.name, error);
            this.progressInfos[index].value = 0;
            this.notifierService.notify("error", errorMessage);
          }
        );
    });
    this.selectedFiles = undefined;
  }

  validateFile(fileName: string): boolean {
    const validFilename = REGEXP_FILE_NAME.test(fileName);
    return validFilename;
  }
}

@Component({
  selector: "app-dialog-data-file-content",
  templateUrl: "dialog-data-file-content.component.html",
})
export class DialogDataFileContentComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogData) {}
}

export interface DialogData {
  text: string;
}
